import {useRouting} from '@/composables/use-routing.js'

/**
 * Navigation helpers for moving across the app
 */
export function useNavigation() {

  //Routing
  const {pushRoute, withParams} = useRouting()

  //Home
  const goToHome = (...args) => pushRoute('home', ...args)

  //Enrollments
  const goToEnroll = (...args) => pushRoute('enroll', ...args)
  const goToManageEnrollment = (enrollmentId, ...args) => pushRoute(
    withParams('manage-enrollment', {enrollmentId}), ...args
  )

  //Conversation views for channel/enrollment
  const goToConversationForChannelId = (channelId, ...args) => pushRoute(
    withParams('conversation.channel', {channelId}), ...args
  )
  const goToConversationForEnrollmentId = (enrollmentId, ...args) => pushRoute(
    withParams('conversation.enrollment', {enrollmentId}), ...args
  )

  //Helper to navigate to conversation view for a channel or enrollment model
  const goToConversationForChannel = channel => {
    goToConversationForChannelId(channel.id)
  }
  const goToConversationForEnrollment = enrollment => {
    if (enrollment.hasChannel) {
      goToConversationForChannelId(enrollment.channel.id)
    }
    else {
      goToConversationForEnrollmentId(enrollment.id)
    }
  }

  //Follow deep link provided by Teams
  const followTeamsDeepLink = deepLink => {

    //Enrollment management (backwards compatibility)
    if (deepLink === 'manage-enrollments' || deepLink === 'enrollments-overview' || deepLink === 'home') {
      goToHome()
    }

    //Differentiate between enrollment and channel deep links
    else if (deepLink.startsWith('channel/')) {
      goToConversationForChannelId(deepLink.split('/')[1])
    }
    else if (deepLink.startsWith('enrollment/')) {
      goToConversationForEnrollmentId(deepLink.split('/')[1])
    }

    //Fall back to enrollment view (v2)
    else {
      goToConversationForEnrollmentId(deepLink)
    }
  }

  //Expose interface
  return {

    //Home
    goToHome,

    //Enrollments
    goToEnroll,
    goToManageEnrollment,

    //Conversation views
    goToConversationForChannelId,
    goToConversationForEnrollmentId,
    goToConversationForChannel,
    goToConversationForEnrollment,

    //Teams deep link helper
    followTeamsDeepLink,
  }
}
